import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from '../utils/google-analytics';

/**
 * Custom hook to track page views in Google Analytics
 * Automatically tracks route changes
 */
export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname + location.search, document.title);
    }, [location.pathname, location.search]);
};
